/* tslint:disable:import-blacklist */
import * as number from 'bignumber.js';

number.BigNumber.config({ ROUNDING_MODE: number.BigNumber.ROUND_HALF_CEIL });
export class BigNumber extends number.BigNumber {}
